import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { styled, Skeleton } from '@mui/material';
import { Children } from 'react';
import { capitalize } from '../../../utils/string.js';
import '../../Icons/Add.js';
import '../../Icons/Application.js';
import '../../Icons/AppStore.js';
import '../../Icons/Arrow.js';
import '../../Icons/At.js';
import '../../Icons/Attach.js';
import '../../Icons/Bank.js';
import '../../Icons/Battery.js';
import '../../Icons/Bell.js';
import '../../Icons/Blocked.js';
import '../../Icons/Calendar.js';
import '../../Icons/Card.js';
import '../../Icons/CaretDown.js';
import '../../Icons/CaretLeft.js';
import '../../Icons/CaretRight.js';
import '../../Icons/CaretUp.js';
import '../../Icons/Checkbox.js';
import '../../Icons/CheckboxChecked.js';
import '../../Icons/CheckboxIndeterminate.js';
import '../../Icons/ChevronLeft.js';
import ChevronRight from '../../Icons/ChevronRight.js';
import '../../Icons/Company.js';
import '../../Icons/Copy.js';
import '../../Icons/Currency.js';
import '../../Icons/Customers.js';
import '../../Icons/Dash.js';
import '../../Icons/Dashboard.js';
import '../../Icons/DirectionDown.js';
import '../../Icons/DirectionUp.js';
import '../../Icons/Document.js';
import '../../Icons/DoubleChevronLeft.js';
import '../../Icons/DoubleChevronRight.js';
import '../../Icons/DoubleDirectionDown.js';
import '../../Icons/DoubleDirectionUp.js';
import '../../Icons/Download.js';
import '../../Icons/Edit.js';
import '../../Icons/ExclamationMark.js';
import '../../Icons/ExclamationMarkFilled.js';
import '../../Icons/ExternalLink.js';
import '../../Icons/EyeClosed.js';
import '../../Icons/EyeOpen.js';
import '../../Icons/Fingerprint.js';
import '../../Icons/Folder.js';
import '../../Icons/Forever.js';
import '../../Icons/Funnel.js';
import '../../Icons/GooglePlay.js';
import '../../Icons/Iban.js';
import '../../Icons/Id.js';
import '../../Icons/Info.js';
import '../../Icons/InfoFilled.js';
import '../../Icons/Instant.js';
import '../../Icons/Ip.js';
import '../../Icons/Link.js';
import '../../Icons/List.js';
import '../../Icons/Mail.js';
import '../../Icons/Menu.js';
import '../../Icons/Message.js';
import '../../Icons/MessageDot.js';
import '../../Icons/Onboarding.js';
import '../../Icons/Padlock.js';
import '../../Icons/PadlockOpen.js';
import '../../Icons/Percent.js';
import '../../Icons/Play.js';
import '../../Icons/PowerOff.js';
import '../../Icons/ProcessCompleted.js';
import '../../Icons/ProcessCountEight.js';
import '../../Icons/ProcessCountFive.js';
import '../../Icons/ProcessCountFour.js';
import '../../Icons/ProcessCountNineAndMore.js';
import '../../Icons/ProcessCountOne.js';
import '../../Icons/ProcessCountSeven.js';
import '../../Icons/ProcessCountSix.js';
import '../../Icons/ProcessCountThree.js';
import '../../Icons/ProcessCountTwo.js';
import '../../Icons/ProcessFailed.js';
import '../../Icons/ProcessInProgress.js';
import '../../Icons/ProcessNotStarted.js';
import '../../Icons/ProcessPartialInProgress.js';
import '../../Icons/ProcessPaused.js';
import '../../Icons/Profile.js';
import '../../Icons/Progress.js';
import '../../Icons/Provider.js';
import '../../Icons/QuestionMark.js';
import '../../Icons/QuestionMarkFilled.js';
import '../../Icons/Remove.js';
import '../../Icons/Repeat.js';
import '../../Icons/Reset.js';
import '../../Icons/RoundArrow.js';
import '../../Icons/RoundArrowFilled.js';
import '../../Icons/RoundCheckOutlined.js';
import '../../Icons/RoundCheckOutlinedFilled.js';
import '../../Icons/RoundClose.js';
import '../../Icons/RoundCloseFilled.js';
import '../../Icons/RoundLeft.js';
import '../../Icons/RoundLeftFilled.js';
import '../../Icons/RoundMinus.js';
import '../../Icons/RoundMinusFilled.js';
import '../../Icons/RoundPlus.js';
import '../../Icons/RoundPlusFilled.js';
import '../../Icons/RoundRight.js';
import '../../Icons/RoundRightFilled.js';
import '../../Icons/Settings.js';
import '../../Icons/SettingsCog.js';
import '../../Icons/Shield.js';
import '../../Icons/StarFilled.js';
import '../../Icons/StarOutlined.js';
import '../../Icons/Success.js';
import '../../Icons/Timer.js';
import '../../Icons/Trash.js';
import '../../Icons/Upload.js';
import '../../Icons/User.js';
import '../../Icons/VerticalDots.js';
import '../../Icons/World.js';
import '../../Icons/Wrench.js';
import '../../Icons/Zoom.js';
import '../../Listbox/ListBox.js';
import { ListItem } from '../../Listbox/ListItem.js';
import { useClickOutside } from '../../hooks/useClickOutside.js';
import { BreadcrumbsDots } from '../BreadcrumbsDots.js';
import { BREADCRUMBS_CONSTANTS } from '../constants/index.js';
import { useBreadcrumbsWrapper } from './useBreadcrumbsWrapper.js';

function BreadcrumbsWrapper({ children, sx, breakpointWidth = BREADCRUMBS_CONSTANTS.DEFAULT_BREAKPOINT_WIDTH, }) {
    const { ref, isComponentVisible: isDropdownVisible, toggleComponentVisibility: toggleDropdownVisible, setIsComponentVisible: setIsDropdownVisible, } = useClickOutside(false);
    const { wrapperRef, hiddenCrumbs } = useBreadcrumbsWrapper({
        setIsDropdownVisible,
        children,
        breakpointWidth,
    });
    const hiddenCrumbsElements = hiddenCrumbs.map((element, index) => {
        const linkElement = element.querySelector("a");
        const firstChild = element.firstChild;
        const dataset = firstChild === null || firstChild === void 0 ? void 0 : firstChild.dataset;
        const innerText = firstChild === null || firstChild === void 0 ? void 0 : firstChild.innerText;
        const isLink = Boolean(linkElement) && Boolean(linkElement === null || linkElement === void 0 ? void 0 : linkElement.href);
        const textContent = (innerText !== undefined &&
            Boolean(innerText) &&
            capitalize(innerText)) || jsx(Skeleton, { height: 10, width: 75 });
        const testId = (dataset === null || dataset === void 0 ? void 0 : dataset.testid) ? `${dataset.testid}-dropdown` : undefined;
        if (!isLink) {
            return (jsx(ListItem, { "data-testid": testId, children: textContent }, index));
        }
        return (jsx(ListItem, { className: "link", children: jsx(ListBoxLink, { "data-testid": testId, href: linkElement === null || linkElement === void 0 ? void 0 : linkElement.href, children: textContent }) }, index));
    });
    const modifiedChildren = Children === null || Children === void 0 ? void 0 : Children.map(children, (child, index) => {
        const childrenAmount = Children.toArray(children).length;
        const isLastChild = childrenAmount - 1 === index;
        const areAllCrumbsHidden = hiddenCrumbs.length >= childrenAmount - 1;
        const areDotsVisible = Boolean(isLastChild && hiddenCrumbs.length);
        if (areDotsVisible) {
            return (jsxs(Fragment, { children: [jsx(BreadcrumbsDots, { isDropdownVisible: isDropdownVisible, ref: ref, onClick: toggleDropdownVisible, children: [...hiddenCrumbsElements].reverse() }), !areAllCrumbsHidden && jsx(BreadcrumbChevronRight, {}), child] }));
        }
        return (jsxs(Fragment, { children: [child, !isLastChild && jsx(BreadcrumbChevronRight, {})] }));
    });
    return (jsx(Wrapper, { "$isDropdownVisible": isDropdownVisible, ref: wrapperRef, sx: sx, children: modifiedChildren }));
}
const Wrapper = styled("ul")(({ $isDropdownVisible }) => ({
    display: "flex",
    listStyle: "none",
    padding: 0,
    margin: 0,
    width: "100%",
    flexWrap: "wrap",
    maxHeight: BREADCRUMBS_CONSTANTS.BREADCRUMB_MAX_HEIGHT,
    overflow: $isDropdownVisible ? "initial" : "hidden",
    "& > li": {
        alignItems: "center",
    },
}));
const BreadcrumbChevronRight = styled(ChevronRight)(({ theme }) => ({
    display: "flex",
    alignSelf: "center",
    minWidth: BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH,
    color: theme.palette.text.low,
}));
const ListBoxLink = styled("a")(({ theme }) => ({
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    width: "100%",
    fontSize: 14,
    textDecoration: "none",
    display: "flex",
    "&:hover": {
        backgroundColor: theme.palette.primary[50],
    },
}));

export { BreadcrumbsWrapper };
//# sourceMappingURL=BreadcrumbsWrapper.js.map
